export enum ENV {
  DEVELOPMENT = 'development',
  PRODUCTION = 'production',
}

export const PRODUCTION_HOSTNAMES = ['prod-afvalprofiel.geofluxus.com', 'app.geofluxus.com'] as const;

export function isLocalhostHostname(hostname: string) {
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1' || hostname === '[::1]';
}

export function isProductionHostname(hostname: string) {
  return PRODUCTION_HOSTNAMES.includes(hostname as (typeof PRODUCTION_HOSTNAMES)[number]);
}

export function getBrowserMapProvider() {
  return 'mapbox';
}

/** Environment checks */
export function isProduction() {
  const isProdUrl = typeof window !== 'undefined' && isProductionHostname(window.location.hostname);
  const isProdEnv = process.env.NODE_ENV === ENV.PRODUCTION;
  return isProdUrl && isProdEnv;
}
